
define('text!TescoMobile_Checkout/template/minicart/insurance-total.html',[],function () { return '<!-- ko if: cart().monthlyInsurance --><div class="summary-insurance" data-bind="html: $t(\'Plus %1 a month insurance payments in a separate Direct Debit\').replace(\'%1\', \'<b>\' + cart().monthlyInsurance + \'</b>\')"></div><!-- /ko -->';});

